/*
 * Copyright (C) 2018 Frontier Developments PLC.
 */

import {Component, Prop} from 'vue-property-decorator';
import {Action, State} from 'vuex-class';
import {mixins} from 'vue-class-component';
import SteamAuth from '@/mixins/SteamAuth';
import Loading from '@/components/Loading/index.vue';
import PageHeader from '@/components/PageHeader/index.vue';
import {UserSessionStateInterface} from '@/store/modules/user-session/types';
import {userSessionModule} from '@/store/modules/user-session';
import {LoadingState, LoadingStateInterface} from '@/components/Loading/types';

const namespace: string = 'userSessionModule';

/**
 * Authentication (component).
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
@Component({
    name: 'v-login-authenticate',
    components: {
        'c-loading': Loading,
        'c-page-header': PageHeader,
    },
})
export default class Authenticate extends mixins(SteamAuth) {
    @State('userSessionModule') public userSessionModule!: UserSessionStateInterface;
    @Action('authenticate', {namespace}) public authenticate: any;
    @Action('softLogout', {namespace}) public softLogout: any;
    @Prop(String) public code!: string;

    public state: LoadingStateInterface = new LoadingState(true, false);

    /**
     * Mounted life-cycle event.
     */
    public mounted(): void {
        // ensure the user is logged out
        this.softLogout();

        // authenticate the steam user token
        this.authenticateSteamUser();
    }

    /**
     * Authenticate steam user.
     *
     * @returns {Promise<void>}
     */
    private async authenticateSteamUser(): Promise<void> {
        try {
            await this.authenticate({code: this.code});
            this.$router.push({name: 'item'});
        } catch (e) {
            this.$toastr.clear();
            this.$toastr.error(this.$i18n.translate('notification.authentication.failed', {}) || 'Login Failed');
            this.$router.push({name: 'login'});
        }
    }
}
